





















import Vue from 'vue'
import { CommissionerDTO } from '@/services/tender/types'

export default Vue.extend({
  name: 'CommissionerSection',
  props: {
    commissioners: {
      type: Array as () => CommissionerDTO[],
      default: () => {
        return []
      },
    },
  },
})
